module.exports = __webpack_public_path__ + "static/media/ios-swap.e155bcbb.svg";